<div class="main-container" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()" [scrollWindow]="false">
    <div class='row no-gutters messages-header'>
        <div class="col-10">
            <div id='messages-title' [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
                 {{'messages.messages' | translate}} 
            </div>
        </div>
        <div class="col-2">
            <!-- <svg (click)="sortTable('desc')" xmlns="http://www.w3.org/2000/svg" width="6.686" height="11.806" viewBox="0 0 6.686 11.806">
                <path id="Path_5503" data-name="Path 5503"
                    d="M3.342,11.806a1.372,1.372,0,0,1-.98-.408L.262,9.285A.9.9,0,0,1,.9,7.748H2.881V.461a.461.461,0,0,1,.922,0V7.748a.923.923,0,0,1-.922.922H.951l2.066,2.078a.459.459,0,0,0,.652,0L5.734,8.67H5.279a.461.461,0,1,1,0-.922h.507a.9.9,0,0,1,.636,1.538L4.322,11.4a1.372,1.372,0,0,1-.98.408Zm0,0"
                    transform="translate(0.001)" fill="#707070" />
            </svg> -->
            <!-- <svg (click)="sortTable('asc')" xmlns="http://www.w3.org/2000/svg" width="6.686" height="11.806" viewBox="0 0 6.686 11.806">
                <path id="Path_5502" data-name="Path 5502"
                    d="M225.353,11.806a.461.461,0,0,1-.461-.461V4.058h-1.983a.9.9,0,0,1-.636-1.538l2.1-2.113a1.382,1.382,0,0,1,1.96,0l2.1,2.113a.9.9,0,0,1-.636,1.538h-.507a.461.461,0,1,1,0-.922h.454l-2.066-2.078a.459.459,0,0,0-.652,0l-2.066,2.078h1.93a.923.923,0,0,1,.922.922v7.287A.461.461,0,0,1,225.353,11.806Zm0,0"
                    transform="translate(-222.01)" fill="#707070" />
            </svg> -->
        </div>
    </div>
    <div class='titles-container' infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()" [scrollWindow]="false" [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
        <div style='height: 100%;' *ngIf='messageFacade.isLoading'
            class='titles-loading d-flex justify-content-center align-items-center'>
            <div class='d-flex justify-content-center'>
                <mat-spinner [diameter]="70" mode="indeterminate"></mat-spinner>
            </div>
        </div>
        <div *ngFor='let item of messagesTitles' [class.selected]='currentMessageId == item.id'>
            <app-message-title [messageTitle]='item'></app-message-title>
        </div>
    </div>
    <div class='d-flex justify-content-center'>
        <div style='position: absolute;' *ngIf='messageFacade.infiniteScrollSpinner' class='titles-loading'>
            <mat-spinner [diameter]="40" mode="indeterminate"></mat-spinner>
        </div>
    </div>
</div>